import { render, staticRenderFns } from "./TwoFA.vue?vue&type=template&id=cf1ba48e&scoped=true"
import script from "./TwoFA.vue?vue&type=script&lang=js"
export * from "./TwoFA.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf1ba48e",
  null
  
)

export default component.exports